module.exports = __webpack_public_path__ + "img/20250225-01-01.412e1366.png";